<template>
<div>
  <v-simple-table dense>
    <template v-slot:default>
        <thead>
          <tr class="heading">
            <td width="1%">#</td>
            <td width="20%">کالا و واحد</td>
            <td width="25%">مقدار</td>
            <td width="54%">توضیحات</td>
          </tr>
        </thead>

        <tbody>

          <template v-for="(item, index) in items">
            <tr class="item" :key="item.row_id">
              <td id="pt">{{index + 1}}</td>
              <td><MyProductsUnits @setDefaultValue="productDefaultValue($event, index)" v-model="item.product" /></td>
              <td><MyFloat :nodense="true" v-model="item.lending_value" @blur="valueBlur(item)"/></td>
              <td><MyComment label=' ' v-model="item.comment" /></td>
            </tr>
          </template>

    <tr class="total">
      <td colspan="6"></td>
      <!-- <td colspan="4">{{ lendingTotal }}</td> -->
    </tr>

    </tbody>
    </template>
  </v-simple-table>
</div>
</template>

<script>
import MyProductsUnits from '../../components/MyProductsUnits.vue'
import MyFloat from '../../components/MyFloat.vue'
import MyComment from '../../components/MyComment.vue'

export default {
  name: 'lendingTable',
  data() {
    return {
      gtZeroRules: [
        v => !!v || 'فیلد اجباری',
        v => (v && this.rmCamma(v) >= 1) || 'فیلد اجباری'
      ],
    }
  },
  props: [
    'items', 'lendingTotal', 'productDefaultValue', 'valueBlur'
  ],
  components: {
    MyProductsUnits,
    MyFloat,
    MyComment,
  },
}
</script>
